import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.pages.AccountCodeCorrectionPage`

export default defineMessages({
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  accountCodeCorrectionTitle: {
    id: `${scope}.accountCodeCorrectionTitle`,
    defaultMessage: 'Account code correction: approved requests',
  },
})
